<template>
  <div class="action-card bg-white rounded-2 position-relative mb-n6 mx-auto mx-lg-0">
    <div class="p-2 action-card-header bg-gray">

      <EditableIcon v-model="item.icon" :is-editable="isEditable" />

      <ellipsis-button
        v-if="isEditable"
        style="float: right"
        placement="bottom"
        :heading="null"
        :show-options="['slot', 'duplicate', 'delete']"
        @duplicate="onDuplicate"
        @delete="onRemove">

      </ellipsis-button>

      <div style="display: flex; flex-wrap: nowrap">
        <div v-if="item.type && item.type === 'commitment'" class="inline-effort-image" :style="imageStyle">
          <div style="width: 42px; height: 42px"></div>
        </div>
        <div>
          <h4 class="mb-0">08:00 - 09:00 - {{item.title}}</h4>
        </div>
      </div>
      <p class="text-gray m-0 text-truncate">&nbsp;<!--{{item.description}}--></p>
    </div>
    <div class="action-card-details px-3 py-2 pb-6">
      <ul style="list-style-type: disc" class="m-0">
        <li v-for="(action, idx) in item.actions" :key="idx">
          <!-- TODO: See Workflow primitive, recycle component!!! -->
          <span style="color: #666; font-variant: small-caps">{{action.type|capitalize}}:&nbsp;</span>
          <template v-if="action.type === 'SESSION' || action.type === 'PAUSE'">
            <strong>{{action.description}}</strong> for
            {{action.sessionLength}} min
          </template>
          <template v-if="action.type === 'NEXT:DAY'">
            Wait for {{action.repeat}}× days
          </template>
          <template v-if="action.type === 'NEXT:WEEK'">
            Wait for {{action.repeat}}× weeks
          </template>
          <template v-if="action.type === 'NEXT:WEEKDAY'">
            <!-- TODO: localize -->
            Wait until next {{action.weekday}}
          </template>
          <template v-if="action.type === 'NEXT:DATE'">
            Wait until {{action.date ? 'until ' + $options.filters.longDate(action.date) : 'no date'}}
          </template>
        </li>
      </ul>
      <!--<pre>{{item}}</pre>-->
      <el-button v-if="item.actions.length > 1" @click="onExpandComposite" size="mini" :disabled="true" class="mt-4">Expand to edit</el-button>
    </div>
    <div class="action-card-controls text-right">
    </div>
    <div v-if="showConnection" class="workflow-string position-absolute"></div>
  </div>
</template>

<script>
import EditableIcon from './EditableIcon'
import clonedeep from 'lodash.clonedeep'

export default {
  name: "WorkflowComposite",
  props: {
    value: {},
    showConnection: {
      default: true
    },
    isEditable: {
      default: true
    }
  },
  created() {
  },
  data: () => ({
    item: {}
  }),
  watch: {
    value: {
      handler( newValue ) {
        this.item = newValue;
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    commitment() {
      if (this.item.type && this.item.type === 'commitment') {
        return this.$models.commitment
          .with({ goalId: this.item.goalId })
          .subscribeNode(this.item.commitmentId);
      } else {
        return null
      }
    },
    imageSource() {
      if (this.item.type && this.item.type === 'commitment' && this.commitment) {
        if (this.commitment.picture) {
          return this.commitment.picture;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    imageStyle() {
      return {
        backgroundImage: "url(" + this.imageSource + ")",
        "border-color": this.tscColor //this.session.color
      };
    }
  },
  methods: {
    onDuplicate() {
      let item_clone = clonedeep( this.item )
      this.$emit('duplicate', item_clone)
    },
    onRemove() {
      this.$emit('remove');
    },
    onExpandComposite() {
      console.log("onExpandComposite - TODO");
    }
  },
  components: {
    EditableIcon
  }
}
</script>
